var React = require('react');

function So2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.3068 23.2056H28.4701V35.9996H0V23.2056H3.16335V32.8011H25.3068V23.2056Z","fill":"#BBBBBB","key":0}),React.createElement("path",{"d":"M6.61124 22.2551L22.1476 25.5569L22.8007 22.4165L7.26433 19.1134L6.61124 22.2551ZM8.66713 14.7332L23.0592 21.5105L24.3999 18.6001L10.0075 11.8228L8.66713 14.7332ZM12.6495 7.59382L24.8508 17.8671L26.8828 15.3999L14.6815 5.1269L12.6495 7.59382ZM20.5254 0L17.9774 1.91619L27.4525 14.7974L30.0005 12.8815L20.5254 0ZM6.32715 29.603H22.1439V26.4045H6.32715V29.603Z","fill":"#F58025","key":1})]);
}

So2.defaultProps = {"width":"30","height":"36","viewBox":"0 0 30 36","fill":"none"};

module.exports = So2;

So2.default = So2;
